import { Button, Select } from "imagine-ui";
import { DefectStatus, PunchlistText, StatusIcon } from "../..";

interface Props {
  status: DefectStatus;
  onClick: () => void;
  className?: string;
  selected?: boolean;
}

export const StatusButton = (props: Props) => {
  const statusText = PunchlistText.getDefectStatusText(props.status);

  return (
    <div className={props.className}>
      <Button
        outline={!props.selected}
        // className="row border-accent clickable bg-accent-transparent-hover p-sm"
        onClick={props.onClick}
        className="w-full"
        align="left"
        disabled={props.selected}
      >
        <StatusIcon status={props.status} />
        <div className="ml">{statusText}</div>
      </Button>
    </div>
  );
};
